import axios from 'axios';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { useUserStore } from '@/store/useUserStore';
import { useNotificationStore } from '@/store/useNotificationStore';
import { storeToRefs } from 'pinia';

const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		component: () => import('../layouts/AppLayout.vue'),
		meta: {
			auth: true,
		},
		children: [
			{
				path: '',
				meta: { breadcrumb: 'Kokpit' },
				name: 'Dashboard',
				component: () => import('../views/Dashboard/DefaultView.vue'),
			},
			{
				path: 'access-denied',
				name: 'accessDenied',
				meta: { breadcrumb: 'Dostęp zabroniony' },
				component: () => import('../views/AccessDenied/DefaultView.vue'),
			},
			{
				path: 'message',
				component: () => import('../views/Message/DefaultView.vue'),
				children: [
					{
						path: '',
						name: 'messageIndex',
						component: () => import('../views/Message/IndexView.vue'),
					},
					{
						path: ':hash',
						name: 'messageShow',
						component: () => import('../views/Message/IndexView.vue'),
					},
					{
						path: 'create',
						name: 'messageCreate',
						component: () => import('../views/Message/CreateView.vue'),
					},
				],
			},
			{
				path: 'agreement',
				meta: { breadcrumb: 'Umowy' },
				component: () => import('../views/AgreementUser/DefaultView.vue'),
				children: [
					{
						path: '',
						name: 'agreementUserIndex',
						component: () => import('../views/AgreementUser/IndexView.vue'),
					},
					{
						path: ':hash',
						name: 'agreementUserShow',
						meta: { breadcrumb: 'Szczegóły umowy' },
						component: () => import('../views/AgreementUser/UpdateView.vue'),
					},
				],
			},
			{
				path: 'offer',
				meta: { breadcrumb: 'Moja szkoła' },
				component: () => import('../views/Offer/DefaultView.vue'),
				children: [
					{
						path: 'language',
						meta: { parent: 'language', breadcrumb: 'Zajęcia' },
						component: () => import('../views/Language/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'languageIndex',
								component: () => import('../views/Language/IndexView.vue'),
							},
							{
								path: 'create',
								name: 'languageCreate',
								meta: { breadcrumb: 'Dodaj zajęcia' },
								component: () => import('../views/Language/CreateView.vue'),
							},
							{
								path: ':hash',
								name: 'languageUpdate',
								meta: { breadcrumb: 'Edycja zajęć' },
								component: () => import('../views/Language/UpdateView.vue'),
							},
						],
					},
					{
						path: 'course',
						meta: { parent: 'course', breadcrumb: 'Kursy' },
						component: () => import('../views/Course/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'courseIndex',
								component: () => import('../views/Course/IndexView.vue'),
							},
							{
								path: 'create',
								name: 'courseCreate',
								meta: { breadcrumb: 'Utwórz' },
								component: () => import('../views/Course/CreateView.vue'),
							},
							{
								path: ':hash',
								name: 'courseUpdate',
								meta: { breadcrumb: 'Edytuj kurs' },
								component: () => import('../views/Course/UpdateView.vue'),
							},
						],
					},
					{
						path: 'groups',
						meta: { parent: 'groups', breadcrumb: 'Grupy' },
						component: () => import('../views/Groups/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'groupsIndex',
								component: () => import('../views/Groups/IndexView.vue'),
							},
							{
								path: 'create',
								name: 'groupsCreate',
								meta: { breadcrumb: 'Dodaj grupę' },
								component: () => import('../views/Groups/CreateView.vue'),
							},
							{
								path: ':hash',
								name: 'groupsUpdate',
								meta: { breadcrumb: 'Edytuj grupę' },
								component: () => import('../views/Groups/UpdateView.vue'),
							},
						],
					},
					{
						path: 'camp',
						meta: { parent: 'camp', breadcrumb: 'Kolonie, półkolonie' },
						component: () => import('../views/Camp/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'campIndex',

								component: () => import('../views/Camp/IndexView.vue'),
							},
							{
								path: 'create',
								name: 'campCreate',
								meta: { breadcrumb: 'Utwórz kolonię, półkolonię' },
								component: () => import('../views/Camp/CreateView.vue'),
							},
							{
								path: ':hash',
								name: 'campUpdate',
								meta: { breadcrumb: 'Edytuj kolonię, półkolonię' },
								component: () => import('../views/Camp/UpdateView.vue'),
							},
						],
					},
					{
						path: 'lector',
						meta: { breadcrumb: 'Nauczyciele' },
						component: () => import('../views/Lector/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'lectorIndex',
								component: () => import('../views/Lector/IndexView.vue'),
							},
							{
								path: 'create',
								name: 'lectorCreate',
								meta: { breadcrumb: 'Dodaj nauczyciela' },
								component: () => import('../views/Lector/CreateView.vue'),
							},
							{
								path: ':hash',
								name: 'lectorUpdate',
								meta: { breadcrumb: 'Edytuj nauczyciela' },
								component: () => import('../views/Lector/UpdateView.vue'),
							},
						],
					},
					{
						path: 'student',
						meta: { breadcrumb: 'Kursanci' },
						component: () => import('../views/Student/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'studentIndex',
								component: () => import('../views/Student/IndexView.vue'),
							},
							{
								path: 'create',
								name: 'studentCreate',
								meta: { breadcrumb: 'Utwórz kursanta' },
								component: () => import('../views/Student/CreateView.vue'),
							},
							{
								path: ':hash',
								name: 'studentUpdate',
								meta: { breadcrumb: 'Edytuj kursanta' },
								component: () => import('../views/Student/UpdateView.vue'),
							},
						],
					},
					{
						path: 'company',
						meta: { breadcrumb: 'Firmy' },
						component: () => import('../views/Company/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'companyIndex',
								component: () => import('../views/Company/IndexView.vue'),
							},
							{
								path: 'create',
								name: 'companyCreate',
								meta: { breadcrumb: 'Dodaj firmę' },
								component: () => import('../views/Company/CreateView.vue'),
							},
							{
								path: ':hash',
								name: 'companyUpdate',
								meta: { breadcrumb: 'Edytuj firmę' },
								component: () => import('../views/Company/UpdateView.vue'),
							},
						],
					},
					{
						path: 'agreement',
						meta: { breadcrumb: 'Umowy' },
						component: () => import('../views/Agreement/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'agreementIndex',
								component: () => import('../views/Agreement/IndexView.vue'),
							},
						],
					},
					{
						path: 'library',
						meta: { breadcrumb: 'Biblioteka' },
						component: () => import('../views/Library/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'libraryIndex',
								component: () => import('../views/Library/IndexView.vue'),
							},
							{
								path: 'create',
								name: 'libraryCreate',
								meta: { breadcrumb: 'Utwórz pozycję' },
								component: () => import('../views/Library/CreateView.vue'),
							},
							{
								path: ':hash',
								name: 'libraryUpdate',
								meta: { breadcrumb: 'Edytuj pozycję' },
								component: () => import('../views/Library/UpdateView.vue'),
							},
						],
					},
					{
						path: 'storage',
						meta: { parent: 'storage', breadcrumb: 'Menadżer plików' },
						component: () => import('../views/Storage/DefaultView.vue'),
						children: [
							{
								path: ':hash?',
								name: 'driveIndex',
								component: () => import('../views/Storage/IndexView.vue'),
							},
						],
					},
					{
						path: 'task',
						meta: { breadcrumb: 'Zadania' },
						component: () => import('../views/Task/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'task',
								component: () => import('../views/Task/IndexView.vue'),
							},
							{
								path: 'today',
								name: 'taskToday',
								component: () => import('../views/Agreement/IndexView.vue'),
							},
							{
								path: 'week',
								name: 'taskWeek',
								component: () => import('../views/Agreement/IndexView.vue'),
							},
							{
								path: 'overdue',
								name: 'taskOverdue',
								component: () => import('../views/Agreement/IndexView.vue'),
							},
							{
								path: 'project',
								name: 'taskProject',
								meta: { breadcrumb: 'Projekty' },
								component: () => import('../views/Task/ProjectView.vue'),
							},
							{
								path: 'folder',
								name: 'taskFolder',
								component: () => import('../views/Task/FolderView.vue'),
							},
							{
								path: ':hash',
								name: 'taskShow',
								component: () => import('../views/Task/ShowView.vue'),
							},
						],
					},
				],
			},
			{
				path: 'schedule',
				meta: { breadcrumb: 'Harmonogramy' },
				component: () => import('../views/Schedule/DefaultView.vue'),
				children: [
					{
						path: 'attendance-log',
						component: () => import('../views/AttendanceLog/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'attendanceLogIndex',
								meta: { breadcrumb: 'Dziennik lekcyjny' },
								component: () => import('../views/AttendanceLog/IndexView.vue'),
							},
						],
					},
					{
						path: 'timetable',
						component: () => import('../views/Timetable/DefaultView.vue'),
						children: [
							{
								path: ':year?/:month?/:day?',
								name: 'timetableIndex',
								meta: { breadcrumb: 'Kalendarz zajęć' },
								component: () => import('../views/Timetable/IndexView.vue'),
							},
						],
					},
					{
						path: 'calendar',
						meta: { breadcrumb: 'Harmonogram zajęć' },
						component: () => import('../views/Calendar/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'scheduleCalendarIndex',
								component: () => import('../views/Calendar/IndexView.vue'),
							},
							{
								path: 'create',
								meta: { breadcrumb: 'Utwórz nowe zajęcia' },
								name: 'scheduleCalendarCreate',
								component: () => import('../views/Calendar/CreateView.vue'),
							},
							{
								path: ':hash',
								meta: { breadcrumb: 'Edytuj zajęcia' },
								name: 'scheduleCalendarUpdate',
								component: () => import('../views/Calendar/UpdateView.vue'),
							},
						],
					},
					{
						path: 'holidays',
						meta: { breadcrumb: 'Urlopy, zwolnienia' },
						component: () => import('../views/Holidays/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'holidaysIndex',
								component: () => import('../views/Holidays/IndexView.vue'),
							},
							{
								path: 'create',
								name: 'holidaysCreate',
								meta: { breadcrumb: 'Dodaj urlop, zwolnienie' },
								component: () => import('../views/Holidays/CreateView.vue'),
							},
							{
								path: ':hash',
								name: 'holidaysUpdate',
								meta: { breadcrumb: 'Edytuj urlop, zwolnienie' },
								component: () => import('../views/Holidays/UpdateView.vue'),
							},
						],
					},
				],
			},
			{
				path: 'learning',
				meta: { breadcrumb: 'Nauka' },
				component: () => import('../views/Learning/DefaultView.vue'),
				children: [
					{
						path: 'housework',
						component: () => import('../views/Housework/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'houseworkIndex',
								component: () => import('../views/Housework/IndexView.vue'),
							},
						],
					},
					{
						path: 'flashcards',
						component: () => import('../views/Flashcards/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'flashcardsIndex',
								component: () => import('../views/Flashcards/IndexView.vue'),
							},
						],
					},
					{
						path: 'tests',
						component: () => import('../views/Tests/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'testsIndex',
								component: () => import('../views/Tests/IndexView.vue'),
							},
						],
					},
				],
			},
			{
				path: 'finance',
				meta: { breadcrumb: 'Finanse' },
				component: () => import('../views/Learning/DefaultView.vue'),
				children: [
					{
						path: 'invoice',
						component: () => import('../views/Invoice/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'invoiceIndex',
								component: () => import('../views/Invoice/IndexView.vue'),
							},
						],
					},
					{
						path: 'rate-lector',
						component: () => import('../views/RateLector/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'rateLectorIndex',
								component: () => import('../views/RateLector/IndexView.vue'),
							},
						],
					},
					{
						path: 'pricelist',
						meta: { breadcrumb: 'Cennik zajęć' },
						component: () => import('../views/Pricelist/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'pricelistIndex',
								component: () => import('../views/Pricelist/IndexView.vue'),
							},
						],
					},
					{
						path: 'pass',
						meta: { breadcrumb: 'Karnety' },
						component: () => import('../views/Pass/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'passIndex',
								component: () => import('../views/Pass/IndexView.vue'),
							},
							{
								path: 'create',
								name: 'passCreate',
								meta: { breadcrumb: 'Dodaj karnet' },
								component: () => import('../views/Pass/CreateView.vue'),
							},
							{
								path: ':hash',
								name: 'passUpdate',
								meta: { breadcrumb: 'Edytuj karnet' },
								component: () => import('../views/Pass/UpdateView.vue'),
							},
						],
					},
					{
						path: 'vindication',
						component: () => import('../views/Vindication/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'vindicationIndex',
								component: () => import('../views/Vindication/IndexView.vue'),
							},
						],
					},
				],
			},
			{
				path: 'user',
				meta: { breadcrumb: 'Uzytkownicy' },
				component: () => import('../views/Users/DefaultView.vue'),
				children: [
					{
						path: 'privileges',
						component: () => import('../views/Privileges/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'privilegesIndex',
								component: () => import('../views/Privileges/IndexView.vue'),
							},
							{
								path: 'create',
								name: 'privilegesCreate',
								component: () => import('../views/Privileges/CreateView.vue'),
							},
							{
								path: ':hash',
								name: 'privilegesUpdate',
								component: () => import('../views/Privileges/UpdateView.vue'),
							},
						],
					},
					{
						path: 'users',
						component: () => import('../views/Users/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'usersIndex',
								component: () => import('../views/Users/IndexView.vue'),
							},
						],
					},
					{
						path: 'activity-log',
						component: () => import('../views/ActivityLog/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'activityLog',
								component: () => import('../views/ActivityLog/IndexView.vue'),
							},
						],
					},
				],
			},
			{
				path: 'report',
				meta: { breadcrumb: 'Raport' },
				component: () => import('../views/Report/DefaultView.vue'),
				children: [
					{
						path: 'frequency',
						component: () => import('../views/Frequency/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'reportFrequency',
								component: () => import('../views/Frequency/IndexView.vue'),
							},
						],
					},
					{
						path: 'finance',
						component: () => import('../views/Finance/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'reportFinance',
								component: () => import('../views/Finance/IndexView.vue'),
							},
						],
					},
				],
			},
			{
				path: 'setting',
				meta: { breadcrumb: 'Ustawienia' },
				component: () => import('../views/Setting/DefaultView.vue'),
				children: [
					{
						path: 'facility',
						meta: { breadcrumb: 'Placówki i sale' },
						component: () => import('../views/Facility/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'facilityIndex',
								component: () => import('../views/Facility/IndexView.vue'),
							},
							{
								path: 'create',
								name: 'facilityCreate',
								meta: { breadcrumb: 'Nowa placówka' },
								component: () => import('../views/Facility/CreateView.vue'),
							},
							{
								path: ':hash',
								name: 'facilityUpdate',
								meta: { breadcrumb: 'Edycja placówki' },
								component: () => import('../views/Facility/UpdateView.vue'),
							},
						],
					},
					{
						path: 'field',
						meta: { breadcrumb: 'Dodatkowe pola' },
						component: () => import('../views/Field/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'fieldIndex',
								component: () => import('../views/Field/IndexView.vue'),
							},
							{
								path: ':hash',
								name: 'fieldUpdate',
								meta: { breadcrumb: 'Lista dodatkowych pól' },
								component: () => import('../views/Field/UpdateView.vue'),
							},
						],
					},
					{
						path: 'semestr',
						meta: { breadcrumb: 'Semestry' },
						component: () => import('../views/Semestr/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'semestrIndex',
								component: () => import('../views/Semestr/IndexView.vue'),
							},
							{
								path: 'create',
								name: 'semestrCreate',
								meta: { breadcrumb: 'Nowy rok szkolny' },
								component: () => import('../views/Semestr/CreateView.vue'),
							},
							{
								path: ':hash',
								name: 'semestrUpdate',
								meta: { breadcrumb: 'Edytuj rok szkolny' },
								component: () => import('../views/Semestr/UpdateView.vue'),
							},
						],
					},
					{
						path: 'age-group',
						meta: { breadcrumb: 'Grupy wiekowe' },
						component: () => import('../views/AgeGroup/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'ageGroupIndex',
								component: () => import('../views/AgeGroup/IndexView.vue'),
							},
							{
								path: 'create',
								name: 'ageGroupCreate',
								meta: { breadcrumb: 'Dodaj grupę wiekową' },
								component: () => import('../views/AgeGroup/CreateView.vue'),
							},
							{
								path: ':hash',
								name: 'ageGroupUpdate',
								meta: { breadcrumb: 'Edytuj grupę wiekową' },
								component: () => import('../views/AgeGroup/UpdateView.vue'),
							},
						],
					},
					{
						path: 'type-group',
						meta: { breadcrumb: 'Rodzaj grup' },
						component: () => import('../views/TypeGroup/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'typeGroupIndex',
								component: () => import('../views/TypeGroup/IndexView.vue'),
							},
							{
								path: 'create',
								name: 'typeGroupCreate',
								component: () => import('../views/TypeGroup/CreateView.vue'),
							},
							{
								path: ':hash',
								name: 'typeGroupUpdate',
								component: () => import('../views/TypeGroup/UpdateView.vue'),
							},
						],
					},
					{
						path: 'my-company',
						component: () => import('../views/MyCompany/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'mySchoolIndex',
								meta: { breadcrumb: 'Dane szkoły' },
								component: () => import('../views/MyCompany/IndexView.vue'),
							},
						],
					},
					{
						path: 'duration',
						meta: { breadcrumb: 'Czas trwania zajęć' },
						component: () => import('../views/Duration/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'durationIndex',
								component: () => import('../views/Duration/IndexView.vue'),
							},
							{
								path: 'create',
								meta: { breadcrumb: 'Dodaj czas zajęć' },
								name: 'durationCreate',
								component: () => import('../views/Duration/CreateView.vue'),
							},
							{
								path: ':hash',
								name: 'durationUpdate',
								meta: { breadcrumb: 'Edytuj czas zajęć' },
								component: () => import('../views/Duration/UpdateView.vue'),
							},
						],
					},
					{
						path: 'message-template',
						component: () => import('../views/MessageTemplate/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'messageTemplateIndex',
								component: () => import('../views/MessageTemplate/IndexView.vue'),
							},
						],
					},
					{
						path: 'package-sms',
						component: () => import('../views/PackageSms/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'packageSmsIndex',
								component: () => import('../views/PackageSms/IndexView.vue'),
							},
						],
					},
					{
						path: 'subscription',
						component: () => import('../views/Subscription/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'subscriptionIndex',
								component: () => import('../views/Subscription/IndexView.vue'),
							},
						],
					},
					{
						path: 'payments',
						meta: { breadcrumb: 'Płatności' },
						component: () => import('../views/Payments/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'paymentsIndex',
								component: () => import('../views/Payments/IndexView.vue'),
							},
						],
					},
					{
						path: 'transfer',
						meta: { breadcrumb: 'Import przelewów' },
						component: () => import('../views/Transfer/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'transferIndex',
								component: () => import('../views/Transfer/IndexView.vue'),
							},
						],
					},
					{
						path: 'email',
						component: () => import('../views/Email/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'emailIndex',
								component: () => import('../views/Email/IndexView.vue'),
							},
						],
					},
					{
						path: 'invoices',
						meta: { breadcrumb: 'Faktury i rozliczenia' },
						component: () => import('../views/Invoices/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'invoicesIndex',
								component: () => import('../views/Invoices/IndexView.vue'),
							},
						],
					},
					{
						path: 'agreement',
						meta: { breadcrumb: 'Umowy' },
						component: () => import('../views/SettingAgreement/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'settingAgreementIndex',
								component: () => import('../views/SettingAgreement/IndexView.vue'),
							},
						],
					},
					{
						path: 'website',
						meta: { breadcrumb: 'Strona www' },
						component: () => import('../views/Website/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'websiteIndex',
								component: () => import('../views/Website/IndexView.vue'),
							},
						],
					},
					{
						path: 'template-agreement',
						meta: { breadcrumb: 'Szablony umów' },
						component: () => import('../views/TemplateAgreement/DefaultView.vue'),
						children: [
							{
								path: '',
								name: 'templateAgreementIndex',
								component: () => import('../views/TemplateAgreement/IndexView.vue'),
							},
							{
								path: 'create',
								meta: { breadcrumb: 'Utwórz szablon umowy' },
								name: 'templateAgreementCreate',
								component: () => import('../views/TemplateAgreement/CreateView.vue'),
							},
							{
								path: ':hash',
								meta: { breadcrumb: 'Edycja szablonu umowy' },
								name: 'templateAgreementUpdate',
								component: () => import('../views/TemplateAgreement/UpdateView.vue'),
							},
						],
					},
				],
			},
			{
				path: 'todo',
				component: () => import('../views/Todo/DefaultView.vue'),
				children: [
					{
						path: '',
						name: 'todoIndex',
						component: () => import('../views/Todo/IndexView.vue'),
					},
					{
						path: ':hash',
						name: 'todoShow',
						component: () => import('../views/Todo/ShowView.vue'),
					},
				],
			},
			{
				path: 'notification',
				component: () => import('../views/Notification/DefaultView.vue'),
				children: [
					{
						path: '',
						name: 'notificationIndex',
						component: () => import('../views/Notification/IndexView.vue'),
					},
					{
						path: ':hash',
						name: 'notificationShow',
						component: () => import('../views/Notification/ShowView.vue'),
					},
				],
			},
			{
				path: 'account',
				meta: { breadcrumb: 'Moje konto' },
				component: () => import('../views/Account/DefaultView.vue'),
				children: [
					{
						path: '',
						name: 'accountIndex',
						meta: { breadcrumb: 'Moje dane' },
						component: () => import('../views/Account/IndexView.vue'),
					},
					{
						path: 'access',
						name: 'accountAccess',
						meta: { breadcrumb: 'Dane do logowania' },
						component: () => import('../views/Account/AccessView.vue'),
					},
					{
						path: 'setting',
						name: 'accountSetting',
						meta: { breadcrumb: 'Ustawienia konta' },
						component: () => import('../views/Account/SettingView.vue'),
					},
					{
						path: 'log',
						name: 'accountLog',
						meta: { breadcrumb: 'Historia mojej aktywności' },
						component: () => import('../views/Account/LogView.vue'),
					},
				],
			},
		],
	},
	{
		path: '/auth',
		component: () => import('../layouts/AuthLayout.vue'),
		meta: {
			authLayout: true,
		},
		children: [
			{
				path: 'login',
				name: 'authLogin',
				component: () => import('../views/Auth/LoginView.vue'),
			},
			{
				path: 'register',
				name: 'authRegister',
				component: () => import('../views/Auth/RegisterView.vue'),
			},
			{
				path: 'reset',
				name: 'authReset',
				component: () => import('../views/Auth/ResetView.vue'),
			},
			{
				path: 'reset/:hash',
				name: 'authResetForm',
				component: () => import('../views/Auth/ResetFormView.vue'),
			},
			{
				path: 'activate/:hash',
				name: 'authActivate',
				component: () => import('../views/Auth/ActivateView.vue'),
			},
		],
	},
];

const hasAccessToModule = async (to: any) => {
	try {
		const request = await axios.post('/module/access', to);
		return request.data;
	} catch (e:any) {
		if (e.response.status === 401) {
			localStorage.removeItem('auth._token');
			window.location.reload();
		}
	}
	return false;
};

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

router.beforeEach(async (to, from, next) => {
	const storeUser = useUserStore();
	const notificationStore = useNotificationStore();

	const { authenticated } = storeToRefs(storeUser);

	if (localStorage.getItem('auth._token') !== undefined && localStorage.getItem('auth._token') !== null) {
		if (!authenticated.value) {
			try {
				const requestUser = await axios.get('/user');
				const { data } = requestUser;
				const token = localStorage.getItem('auth._token');

				storeUser.setAuthenticated(true);
				storeUser.setUser(data.user);
				storeUser.setToken(token);
				storeUser.setIdSchool(data.id_school);
				storeUser.setIdUserRole(data.id_user_role);
				storeUser.setWorkspaces(data.workspaces);
				storeUser.setModule(data.module);
				storeUser.setSemestr(data.semestr);

				if (data.semestr && data.semestr.length > 0) {
					storeUser.setCurrentSemestr(data.semestr[0].hash);
					axios.defaults.headers.common['Hash-Semestr'] = data.semestr[0].hash;
				}

				if (data.id_school) {
					axios.defaults.headers.common['Id-School'] = data.id_school;
				}

				if (data.id_user_role) {
					axios.defaults.headers.common['Id-User-Role'] = data.id_user_role;
				}

				axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
				axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
				axios.defaults.headers.common['Access-Control-Allow-Credentials'] = true;
				axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Content-Type,Authorization';
				axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE,OPTIONS';

				if (to.matched.some((record) => record.meta.authLayout)) {
					next({ path: '/' });
				}

				const hasAccess = await hasAccessToModule(to);
				if (!hasAccess) {
					next('/access-denied');
				}
				(async () => {
					await notificationStore.getNotification();
				})();
			} catch (err: any) {
				const { response } = err;
				const { status } = response;
				if (status === 401) {
					localStorage.removeItem('auth._token');
					window.location.reload();
				}
			}
		} else if (to.name !== 'accessDenied') {
			const hasAccess = await hasAccessToModule({ name: to.name });
			if (!hasAccess) {
				next('/access-denied');
			}
		}
	} else if (to.matched.some((record) => record.meta.auth)) {
		next('/auth/login');
	}

	next();
});

export default router;
